import { useState, type VoidFunctionComponent } from 'react';

import type { SetState } from '../../../../types';
import type { ProjectTypes, ReportExclusionOptions } from '../shared/types';

import Filter from './shared/components/Filter';
import { ReportCategories } from './utils';
import type { OnApply } from './shared/components/Filter';
import type { FormatSelection } from './shared/components/FormatSelect';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption, LicensingFormat } from './shared/types';

type LicensingFiltersProps = {
  onApply: OnApply;
  appliedFormat: FormatName | null;
  setIsDirty: SetState<boolean>;
  isApplyButtonDisabled: boolean;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  excludeOptions: ReportExclusionOptions;
  projectType: ProjectTypes;
};

const LicensingFilters: VoidFunctionComponent<LicensingFiltersProps> = ({
  isApplyButtonDisabled,
  onApply,
  appliedFormat,
  setIsDirty,
  includeOptions,
  dependencyMetadataOptions,
  excludeOptions,
  projectType,
}: LicensingFiltersProps) => {
  const htmlFormat: LicensingFormat = { label: 'HTML', value: 'HTML' };
  const formats: LicensingFormat[] = [
    htmlFormat,
    { label: 'PDF', value: 'PDF' },
    { label: 'CSV', value: 'CSV' },
    { label: 'Markdown', value: 'Markdown' },
    { label: 'Plain Text', value: 'Plain Text' },
  ];
  const [format, setFormat] = useState<FormatSelection>(htmlFormat);
  return (
    <Filter
      isApplyButtonDisabled={isApplyButtonDisabled}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      category={ReportCategories.Licensing}
      appliedFormat={appliedFormat}
      format={format}
      setFormat={setFormat}
      setIsDirty={setIsDirty}
      formats={formats}
      onApply={onApply}
      excludeOptions={excludeOptions}
      projectType={projectType}
    />
  );
};

export default LicensingFilters;
